/* global  */ // tUrl等のグローバル変数を宣言する
import './_smoothScroll' // スムーズスクロール
import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  let accBtn = 'sp-menu' // このIDを基準としたアコーディオン
  $('#' + accBtn + '-open,.' + accBtn + '-close,#' + accBtn + ' a,#overlay').on('click', function() {
    $('#' + accBtn + ',#' + accBtn + '-open,.' + accBtn + '-close,#overlay').toggleClass('active')
    scrollLock('html,body', '#overlay')
  })

  /*
    ######   ######          ##        #######   ######  ##    ##
   ##    ## ##    ##         ##       ##     ## ##    ## ##   ##
   ##       ##               ##       ##     ## ##       ##  ##
    ######  ##       ####### ##       ##     ## ##       #####
         ## ##               ##       ##     ## ##       ##  ##
   ##    ## ##    ##         ##       ##     ## ##    ## ##   ##
    ######   ######          ########  #######   ######  ##    ##
  */
  /**
   * Safariを含めた全ブラウザでスクロールをロックする
   * オーバーレイの状態を基準にONOFFを切り替え
   * scrollLock('html,body', '#overlay')
   *
   * @function scrollLock
   * @param  {String} [selecter='html,body']  固定対象セレクタ
   * @param  {String} [trigger='#overlay']  判定用セレクタ
   * @return {Boolean} false
   */

  let scrollTop
  function scrollLock(selecter = 'html,body', trigger = '#overlay') {
    if ($(trigger).hasClass('active')) {
      // スクロール停止
      scrollTop = $(window).scrollTop()
      $(selecter).css({ position: 'fixed', top: -scrollTop })
    } else {
      // スクロール停止解除
      $(selecter).css({ position: 'static', top: '0' })
      $(selecter).scrollTop(scrollTop)
    }
  }

  /*
        ######  ##       #### ########  ########
       ##    ## ##        ##  ##     ## ##
       ##       ##        ##  ##     ## ##
        ######  ##        ##  ##     ## ######
             ## ##        ##  ##     ## ##
       ##    ## ##        ##  ##     ## ##
        ######  ######## #### ########  ########
*/
  if ($('#mv-slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const mvSwiper = new Swiper('#mv-slide', {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      grabCursor: true, // 掴みカーソル
      //    simulateTouch: false, // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
      fadeEffect: {
        // フェードオプション
        crossFade: true // クロスフェード
      },
      autoplay: {
        // オートオプション
        delay: 7000, // 待機時間
        disableOnInteraction: false // 操作されたらオート解除
      },
      navigation: {
        nextEl: '.swiper-button-next--mv', // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--mv' // 次のページボタンを呼び出す要素
      },
      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--mv', // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true // クリックでジャンプ可能にする
      },
      breakpoints: {
        // 指定px以下時にオプション切り替え
        768: {}
      }
    })
  }
  if ($('#int-slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const intSwiper = new Swiper('#int-slide', {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 1000, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      grabCursor: true, // 掴みカーソル
      fadeEffect: {
        // フェードオプション
        crossFade: true // クロスフェード
      },
      navigation: {
        nextEl: '.swiper-button-next--int', // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--int' // 次のページボタンを呼び出す要素
      }
    })
  }
  if ($('#job-slide')[0]) {
    let slideVal = parseInt($('#job-slide').attr('data-slide'), 10)
    if (slideVal >= 3) {
      slideVal = 2
    }
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const intSwiper = new Swiper('#job-slide', {
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 1000, // アニメ速度
      loop: true, // ループ
      // loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: slideVal, //表示数変更
      spaceBetween: 20, //スライド同士の間隔を空ける
      grabCursor: true, // 掴みカーソル
      fadeEffect: {
        // フェードオプション
        crossFade: true // クロスフェード
      },
      navigation: {
        nextEl: '.swiper-button-next--job', // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--job' // 次のページボタンを呼び出す要素
      }
    })
  }
  if ($('#job-sp-slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const intSwiper = new Swiper('#job-sp-slide', {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 1000, // アニメ速度
      loop: true, // ループ
      // loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
      preloadImages: false, // スライド内の画像を読み終えてから開始
      spaceBetween: 20, //スライド同士の間隔を空ける
      grabCursor: true, // 掴みカーソル
      fadeEffect: {
        // フェードオプション
        crossFade: true // クロスフェード
      },
      navigation: {
        nextEl: '.swiper-button-next--job-sp', // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--job-sp' // 次のページボタンを呼び出す要素
      }
    })
  }

  /*
       ########    ###    ########
          ##      ## ##   ##     ##
          ##     ##   ##  ##     ##
          ##    ##     ## ########
          ##    ######### ##     ##
          ##    ##     ## ##     ##
          ##    ##     ## ########
*/
  $('.tab-area').each(function() {
    const btn = $(this).find('.tab-btn')
    const item = $(this).find('.tab-item')
    btn.on('click', function() {
      const index = $(this)[0].dataset.tab // data-tab属性から対応アイテムのセレクタを取得
      btn.removeClass('active') // activeを全て解除
      item.removeClass('active') // activeを全て解除
      $(this).addClass('active')
      $(index).addClass('active')
    })
  })

  /*
#######  ###### ######   ######  ##      ##
##      ##      ##   ## ##    ## ##      ##
####### ##      ######  ##    ## ##      ##
     ## ##      ##   ## ##    ## ##      ##
#######  ###### ##   ##  ######  ####### #######
*/

  // スクロールナビゲーション
  const fps = 10 // FPS設定 60まで上げるとほとんど負荷低減効果がなくなる
  const frameTime = 1000 / fps
  let isScroll = false // スクロールフラグ
  let scrollY = 0 // 縦方向のスクロール量
  // 処理頻度テスト用
  // let scrollCount = 0
  // let actionCount = 0
  if (document.getElementById('scrollNav')) {
    document.addEventListener('scroll', function(ev) {
      // スクロール量の更新だけを行う
      scrollY = window.pageYOffset // スクロール量更新
      isScroll = true // フラグON
      // console.log('Scroll:' + ++scrollCount)
    })
    scrollNav()
  }
  function scrollNav() {
    // スクロールフラグが立っているときだけDOM書き換え
    if (isScroll) {
      $('.js-scrollNavPoint').each(function() {
        // 画面に収まった要素をactive
        let targetStart = $(this).offset().top // 画面上部からのターゲットの位置
        let targetEnd = targetStart + $(this).innerHeight() + $(window).innerHeight() // 画面下部からのターゲットの位置
        let scloll = scrollY + $(window).innerHeight() / 2 // ページ最上部からのスクロール量 + ビューポートの半分 = 画面の中間
        if (window.matchMedia('(min-width:769px)').matches) {
          scloll = scrollY + $(window).innerHeight() / 2 // ページ最上部からのスクロール量 + ビューポートの半分 = 画面の中間に走査線を張る
        } else {
          scloll = scrollY + $(window).innerHeight() // ページ最上部からのスクロール量 + ビューポートの半分 = 画面の下端に走査線を張る
        }

        if (scloll > targetStart && scloll < targetEnd) {
          // ターゲットの上端～下端に走査線が入っている

          $('.js-scrollNav').removeClass('active')
          $('.' + $(this).attr('id')).addClass('active')
        }
      })
      isScroll = false // フラグをOFFに戻す
      // console.log('Action:' + ++actionCount)
    }
    setTimeout(scrollNav, frameTime) // 次回の処理を登録
  }

  /*
       ##     ##  #######  ########     ###    ##
       ###   ### ##     ## ##     ##   ## ##   ##
       #### #### ##     ## ##     ##  ##   ##  ##
       ## ### ## ##     ## ##     ## ##     ## ##
       ##     ## ##     ## ##     ## ######### ##
       ##     ## ##     ## ##     ## ##     ## ##
       ##     ##  #######  ########  ##     ## ########
*/
  $('.js-modal-open').on(' click', function() {
    const target = $(this).attr('data-target')
    $(target).addClass('active')
    $('#modal-overlay').addClass('active')
    scrollLock('html,body', '#modal-overlay')
  })
  $('.js-modal-close,#modal-overlay').on('click', function() {
    $('.js-modal').removeClass('active')
    $('#modal-overlay').removeClass('active')
    scrollLock('html,body', '#modal-overlay')
  })

  /*
  ##       ######  #######  #####  ######
  ##      ##    ##    ###  ##   ## ##   ##
  ##      ##    ##   ###   ####### ##   ##
  ##      ##    ##  ###    ##   ## ##   ##
  #######  ######  ####### ##   ## ######
  */
  /* global lozad */
  lozad('.lozad', {
    rootMargin: '1%',
    loaded: function(el) {
      el.classList.add('active') // 画面に交差した要素をactive
    }
  }).observe()

  /*
 ########     ###    ########  ######## ####  ######  ##       ########
 ##     ##   ## ##   ##     ##    ##     ##  ##    ## ##       ##
 ##     ##  ##   ##  ##     ##    ##     ##  ##       ##       ##
 ########  ##     ## ########     ##     ##  ##       ##       ######
 ##        ######### ##   ##      ##     ##  ##       ##       ##
 ##        ##     ## ##    ##     ##     ##  ##    ## ##       ##
 ##        ##     ## ##     ##    ##    ####  ######  ######## ########
*/

  /* global createjs particlejs */

  const stage = new createjs.Stage('lucciolaMvBG')
  const particleSystem = new particlejs.ParticleSystem()
  stage.addChild(particleSystem.container)
  particleSystem.importFromJson({
    bgColor: '#00000',
    width: 2000,
    height: 750,
    emitFrequency: 66,
    startX: 1005.7499846853318,
    startXVariance: 3000,
    startY: 364.3840509551244,
    startYVariance: 522,
    initialDirection: '0',
    initialDirectionVariance: '360',
    initialSpeed: 3.3,
    initialSpeedVariance: 3.6,
    friction: 0.0365,
    accelerationSpeed: 0.122,
    accelerationDirection: 268.2,
    startScale: 0.55,
    startScaleVariance: 1,
    finishScale: 0.31,
    finishScaleVariance: '0',
    lifeSpan: 40,
    lifeSpanVariance: 76,
    startAlpha: 1,
    startAlphaVariance: 0.03,
    finishAlpha: '0.35',
    finishAlphaVariance: 0.5,
    shapeIdList: ['blur_circle'],
    startColor: {
      hue: 58,
      hueVariance: 17,
      saturation: 89,
      saturationVariance: '78',
      luminance: 78,
      luminanceVariance: 7
    },
    blendMode: true,
    alphaCurveType: '1',
    VERSION: '1.0.0'
  })
  // フレームレートの設定
  createjs.Ticker.framerate = 60
  // requestAnimationFrameに従った呼び出し
  createjs.Ticker.timingMode = createjs.Ticker.RAF
  if (document.getElementById('lucciolaMvBG')) {
    // 定期的に呼ばれる関数を登録
    createjs.Ticker.addEventListener('tick', handleTick)
  }
  function handleTick() {
    particleSystem.update()
    stage.update()
  }

  /*
       ########  ##     ##  ######  ##     ##
       ##     ## ##     ## ##    ## ##     ##
       ##     ## ##     ## ##       ##     ##
       ########  ##     ##  ######  #########
       ##        ##     ##       ## ##     ##
       ##        ##     ## ##    ## ##     ##
       ##         #######   ######  ##     ##
*/
  $(document).on('click', '.js-push', function() {
    const url = $(this).attr('href') // 取得URL
    history.replaceState(null, null, url)
    return false
  })

  /*
          ###          ##    ###    ##     ##
         ## ##         ##   ## ##    ##   ##
        ##   ##        ##  ##   ##    ## ##
       ##     ##       ## ##     ##    ###
       ######### ##    ## #########   ## ##
       ##     ## ##    ## ##     ##  ##   ##
       ##     ##  ######  ##     ## ##     ##
*/

  $(document).on('click', '.js-ajax', function() {
    const url = $(this).attr('href') // 取得先のURL
    const from = '#news' // 取得する要素
    const to = '#news-area' // 書き換える場所
    $(to).html('<div class="md-loading active"></div>')
    $.ajax({
      url: url,
      dataType: 'html'
    })
      .done(function(data) {
        const outHtml = $($.parseHTML(data)) //parse
        $(to).html(outHtml.find(from)[0].outerHTML)
      })
      .fail(function(data) {})
      .always(function(data) {})
    return false
  })

  $(document).on('click', '.js-ajax', function() {
    $('html , body')
      .not(':animated')
      .animate({ scrollTop: $('#ajax-area').offset().top - $('#header').outerHeight() }, 500, 'swing')
  })
})
